import React from 'react'

interface RoleCardIconProps {
  size?: number
  color?: string
  className?: string
}

const RoleCardIcon: React.FC<RoleCardIconProps> = ({
  size = 32,
  color = 'white',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      {/* 用户头像圆形 */}
      <circle cx="16" cy="13" r="4" fill={color} />
      {/* 用户身体/肩膀部分 */}
      <path
        d="M10 21.5C10 19.2909 11.7909 17.5 14 17.5H18C20.2091 17.5 22 19.2909 22 21.5C22 22.0523 21.5523 22.5 21 22.5H11C10.4477 22.5 10 22.0523 10 21.5Z"
        fill={color}
      />
    </svg>
  )
}

export default RoleCardIcon
